/* ------------------------------------------ GRYFF PAGE SELECTOR - CHRIS 18.08.2016 ----------------------------------------- */
(function (jQuery) {
  jQuery.gfPageSelector = function (element, options) {
    const defaults = {
      onSuccess: function () {},
      detectChange: function () {},
    };
    this.settings = {};

    const $element = jQuery(element);
    const _this = this;

    const _cSelector =
      '<a id="gf-pick-page" class="button" href="#"><i class="fa fa-crosshairs" aria-hidden="true"></i> Pick a Page</a>';
    const _mdPageSelector =
      '<div id="md-page-selector" class="md-modal md-draggable"> <div class="md-content"> <div class="md-modal-handle"> <span class="md-title">Pick a page<span></span></span> </div> <div class="md-tabs-content"> <div class="md-body"> <input type="text" id="search-page" name="search-page" value="" placeholder="Search by page name..." /> <div class="page-list"> <br /> <p class="text-center">Loading pages... You can create a new page in Left Sidebar.</p> <br /> </div> </div> </div> <div class="md-footer"> <button class="btnCancel" class="cancel">Cancel</button> </div> </div> <div class="md-controls"> <button class="btnClose"><i class="fa fa-times" aria-hidden="true"></i></button> </div></div>';

    /* Editor */
    const $divContentHidden = jQuery('#divContentHidden');

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);

      if ($element.next('#gf-pick-page').length == 0) {
        $element.after(_cSelector);
      }
      this.applyEvents();
    };

    this.applyEvents = function () {
      $element
        .next('#gf-pick-page')
        .off()
        .on('click', function () {
          $divContentHidden.append(_mdPageSelector);

          const $activeModal = jQuery('#md-page-selector');

          $activeModal.gfModal({
            onCancel: function () {
              $activeModal.remove();
            },
          });
          // show modal
          $activeModal.data('gfmodal').setWidth('500px').centerModal().show();

          // update stuffs
          const $pageList = $activeModal.find('.page-list');
          const html = $gfPagesManager.data('gfpagesmanager').getPageList(5);

          $pageList.html(html);
          _this.bindPageEvents($activeModal, $pageList);

          $activeModal
            .find('#search-page')
            .off()
            .on('keyup paste', function () {
              const input = jQuery(this).val().toLowerCase();

              const html = $gfPagesManager.data('gfpagesmanager').search(input, true);

              $pageList.html(html);
              _this.bindPageEvents($activeModal, $pageList);

              return false;
            });
        });
    };

    this.bindPageEvents = function ($activeModal, $pageList) {
      $pageList
        .find('ul li')
        .off()
        .on('click', function () {
          const pageTitle = jQuery(this).attr('data-title');
          const pageId = jQuery(this).attr('data-id');
          const pageHandle = jQuery(this).attr('data-handle');

          $element.val(pageTitle).trigger('input-change');
          $element.attr('data-value', pageTitle);

          $element.parent().siblings('.columns').children('#page_id').val(pageId);
          $element.parent().siblings('.columns').children('#page_id').attr('default-value', pageId);

          $element.parent().siblings('.columns').children('#page_handle').val(pageHandle);
          $element.parent().siblings('.columns').children('#page_handle').attr('default-value', pageHandle);

          $element.effect('highlight', { color: '#afd23e' }, 1000);

          $activeModal.data('gfmodal').hide();

          _this.settings.detectChange();

          return false;
        });

      $pageList
        .find('#searchAdvanced')
        .off()
        .on('click', function () {
          const term = $activeModal.find('#search-page').val().toLowerCase();

          $gfPagesManager.data('gfpagesmanager').searchAdvanced(term, true, function (html) {
            $collecitonList.html(html);
            _this.bindPageEvents($activeModal, $collecitonList);
          });

          return false;
        });
    };

    this.init();
  };

  jQuery.fn.gfPageSelector = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfpageselector')) {
        const plugin = new jQuery.gfPageSelector(this, options);
        jQuery(this).data('gfpageselector', plugin);
      }
    });
  };
})(jQuery);
